import { Link } from 'react-router-dom'
import type { NavLink } from '@/types/NavLink'

interface NavItemProps extends NavLink {
  className?: string
  onClick?: () => void
}

// Utilise react-router pour les vraies routes ("/…"), une ancre classique sinon
// (les "#…" ciblent des sections de la page d'accueil, pas encore toutes construites en pages).
export default function NavItem({ label, href, className, onClick }: NavItemProps) {
  if (href.startsWith('/') && !href.startsWith('/#')) {
    return (
      <Link to={href} onClick={onClick} className={className}>
        {label}
      </Link>
    )
  }

  return (
    <a href={href} onClick={onClick} className={className}>
      {label}
    </a>
  )
}
